export const theme = {
  colors: {
    white: '#FFFFFF',
    dirtyWhite: '#e3e1e1',
    lightGrey: '#F7F8FA',
    grey: '#C0c7D6',
    darkGrey: '#737C8E',
    black: '#111111',
    success: '#8FC881',
    error: '#FF8383',
    warning: '#E1D888',
    darkPurple: '#C0C7D6',
    lightPurple: '#ECEFF7',
  },
  fontSize: {
    xxxl: '32px',
    xxl: '27px',
    xl: '22px',
    l: '17px',
    m: '12px',
    s: '11px',
  },
};
